import { Dispatch, MutableRefObject, SetStateAction, useEffect, useRef, useState } from 'react';

export default function useComponentVisible(
  initialIsVisible: boolean,
  onClickOutside?: () => void
): {
  ref: MutableRefObject<any>;
  isComponentVisible: boolean;
  setIsComponentVisible: Dispatch<SetStateAction<boolean>>;
} {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef<any>(null);

  const handleClickOutside = (event: any): any => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
      if (onClickOutside) onClickOutside();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return { ref, isComponentVisible, setIsComponentVisible };
}
